module.exports = __webpack_public_path__ + "static/media/IMG_3565-min.0edd3e0b.JPG";